// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Form from 'antd/lib/form';
import Button from 'components/common/Button';
import Switch from 'antd/lib/switch';
import message from 'antd/lib/message';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import 'antd/lib/input-number/style/css';
import InputNumber from 'antd/lib/input-number';
// APOLLO
import updateNedNotifications from 'ApolloClient/Mutations/updateNedNotifications';
import { graphql } from 'react-apollo';
// CONFIG
import { REMIND_CLIENT_OF_SESSION } from 'lib/constants/cron-job-types';
// COMPONENS
import HeyNedHint from 'components/common/HeyNedHint';

// DOCS
// ====================================
// SessionReminderSwitches
// this is a re-usable form component for "reminders"

const FormItem = Form.Item;

class ReminderSettingItem extends React.PureComponent {
  state = {
    loading: false,
    email: this.props.email || false,
    days: this.props.days || 0,
  };

  handleChange = val => {
    this.setState(val);
  };

  getVariables = () => ({
    params: {
      type: this.props.type,
      email: this.state.email,
      days: this.state.days,
    },
  });

  handleSubmit = async e => {
    e.preventDefault();

    let variables = this.getVariables();
    console.log(variables);
    try {
      await this.props.updateNedNotifications({ variables });
    } catch (err) {
      console.log(err);
    }
    message.success('reminders have been updated!');
  };

  render() {
    // const { setttings, field } = this.props;
    return (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 20 }}>
        <Row>
          <Col xs={10}>
            <FormItem>
              <Switch
                checked={this.state.email}
                checkedChildren="ON "
                unCheckedChildren="OFF"
                onChange={checked => this.handleChange({ email: checked })}
              />
              &nbsp;&nbsp;&nbsp;
              {this.props.label}
            </FormItem>
          </Col>
          <Col xs={10}>
            <FormItem>
              <InputNumber defaultValue={this.state.days} onChange={value => this.handleChange({ days: value })} />
              &nbsp;&nbsp;&nbsp;Days {this.props.label === 'Send a Late Invoice Reminder' ? 'after' : 'before'}{' '}
              <HeyNedHint tooltipText={this.props.tooltip} />
            </FormItem>
          </Col>
          <Col xs={4}>
            <FormItem>
              <Button htmlType="submit" type="primary" disabled={this.state.loading}>
                Save
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

ReminderSettingItem.defaultProps = {
  label: 'Send a Session Reminder',
  type: REMIND_CLIENT_OF_SESSION,
  tooltip:
    "Setup a friendly email reminder that Ned will send out automatically for any sessions with clients. Every day at 11am EST Ned checks for reminders he shoudl send out. If he finds it's time to send out your reminder, he'll issue an email to your client reminding them.",
};

export default graphql(updateNedNotifications, { name: 'updateNedNotifications' })(ReminderSettingItem);



// WEBPACK FOOTER //
// ./src/routes/app-studio/AlertsArea/ReminderSettingItem/index.js